export const totalOrderSvg = (
	<svg
		stroke="currentColor"
		fill="currentColor"
		strokeWidth="0"
		viewBox="0 0 16 16"
		height="1em"
		width="1em"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5 8.186 1.113zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z"></path>
	</svg>
);

export const revenueSvg = (
	<svg
		stroke="currentColor"
		fill="currentColor"
		strokeWidth="0"
		viewBox="0 0 16 16"
		height="1em"
		width="1em"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1H1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"></path>
		<path d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2H3z"></path>
	</svg>
);

export const totalRevenue = (
	<svg
		stroke="currentColor"
		fill="currentColor"
		strokeWidth="0"
		viewBox="0 0 512 512"
		height="1em"
		width="1em"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M210.6 44.39l-7-4.39c-13.7-8.4-30.8-13.28-45.5-8.7-15.8 4.92-28.4 17.09-35 35.37l-9.4-4.84c-16.2-8.34-24.68-8.47-31.71-5.31-5.61 2.51-11.46 8.55-18.09 17.37l82.4 63.71c12.9 4.2 31.8 4.1 50.7-.8 19-4.9 37.9-14.5 51.7-27.4l31.1-76.9c-27.4-21.65-52.4-9.11-69.2 11.89zm53.1 76.51c-17 17.2-42.3 28.8-62 34-6.9 1.8-13.8 3.1-20.5 3.8-3.7 6.1-6.8 12.3-9.2 18.5 4.8 24.4 13.8 44.4 27.3 60.8l-14.4 12c-8.3-10-15.7-20.8-21.3-32.8-.9 23.2 4.3 47.2 12.8 72.2l-17.7 6c-15.6-45.6-20.9-92.3 1-136.3-7.4-.6-14.4-2-20.9-4.3l-.3-.1c-4.3 4.1-8.4 8.4-12.3 12.9-31.57 36.6-48.96 85.3-39.86 123.2 4.87 20.3 13.6 39.5 26.16 55.9 18.4-.4 35.8 0 51.6 6 7.5-.8 15.2-1.3 23.2-1.3 28.5 0 54.3 5.3 73.8 14.5 7.6 3.6 14.5 7.9 20 12.8 0-5.3.8-11 2.4-15.2-8.9-8.4-14.5-18.6-14.5-30.2 0-16.1 10.7-29.4 26.2-39 0-4.6.9-9 2.5-13.2-10.1-8.7-16.6-19.5-16.6-32.1 0-7.9 2.6-15.1 7-21.6-4.4-6.4-7-13.6-7-21.5 0-3.9.6-7.5 1.7-11-9.7-8.6-15.8-19.2-15.8-31.4 0-12.1 6-22.6 15.6-31.1-5.9-4.6-12.2-8.5-18.9-11.5zm111.4 2.3c-26 0-49.5 5.5-65.6 13.6-16.2 8.1-23.8 18.1-23.8 26.7 0 8.7 7.6 18.7 23.8 26.8 16.1 8.1 39.6 13.6 65.6 13.6 11.3 0 22-1.1 31.9-2.9v-17c13.9-2.1 25.4-5.9 32.8-10.8v17.6c12.5-3.6 24.5-16.9 24.8-27.3 0-8.6-7.6-18.6-23.8-26.7-16.2-8.1-39.6-13.6-65.7-13.6zm96.5 67.7c-3.3 3.5-7.2 6.8-11.6 9.8l.2 29c12.6-7.5 18.5-16.2 18.5-23.8 0-4.8-2.3-10-7.1-15zm-171.8 15.4c.3 8.6 7.9 18.3 23.8 26.3 16.2 8.2 39.6 13.6 65.7 13.6 16.3 0 31.6-2.2 44.7-5.8l.7-27.2c-17.2 6-37.6 9.3-59.6 9.3-28.5 0-54.4-5.7-74-15.5-.5-.2-.9-.5-1.3-.7zm2 34.8c-1.4 2.7-2 5.4-2 7.9 0 8.7 7.6 18.7 23.8 26.8 16.2 8.1 39.6 13.5 65.7 13.5 13.2 0 25.7-1.3 37-3.8v-24c-11.6 2.2-24 3.3-37 3.3-28.6 0-54.5-5.6-74.1-15.5-4.9-2.4-9.4-5.2-13.4-8.2zm174.9 0c-6.1 4.3-11.4 7.5-17.6 10.2v22.3c13.3-7.7 19.6-16.7 19.6-24.6 0-2.5-.6-5.2-2-7.9zm7.5 36.8c-2 2-4.2 3.9-6.6 5.8v32.4c10.3-7 15.3-14.7 15.3-21.7 0-5.3-2.9-11-8.7-16.5zm-170.1 14c-.1.9-.2 1.7-.2 2.5 0 8.7 7.6 18.6 23.8 26.7 16.2 8.2 39.7 13.6 65.7 13.6 14.9 0 29.1-1.8 41.4-4.8V300c-16.3 5.2-35.2 8-55.5 8-28.6 0-54.5-5.7-74.1-15.5-.4-.2-.7-.4-1.1-.6zm-13.6 21.4c-8.7 6.5-12.8 13.6-12.8 20 0 8.7 7.6 18.6 23.8 26.8 16.2 8.1 39.6 13.5 65.7 13.5 9.5 0 18.7-.7 27.3-2v-18.2h-1.1c-28.6 0-54.5-5.7-74.1-15.6-12.5-6.2-22.9-14.5-28.8-24.5zM463 343.9c-7.9 2.8-16.5 5.1-25.7 6.6v12.1c1.9-.8 3.8-1.6 5.6-2.5 9.8-5 16.4-10.6 20.1-16.2zm9.2 18.2c-3.8 3.8-8.2 7.2-13.1 10.3V401c13.3-7.6 19.6-16.6 19.6-24.5 0-4.6-2.1-9.6-6.5-14.4zm-348.7 2.8c-10.2.1-21.2 1.4-32.6 4.1-22.81 5.3-42.42 15-55.22 25.7-12.8 10.6-17.8 21.4-16.3 29.1 1.5 7.7 9.4 14.8 24.8 18.9 15.35 4 36.82 4.2 59.62-1.1 9.2-2.2 17.8-5 25.7-8.3v-20.7c14.6-6.5 25.5-14.3 30.4-21.9v24.4c12.1-10.4 16.8-20.8 15.4-28.4-1.4-7.7-9.4-14.8-24.8-18.8-7.7-2-16.9-3.1-27-3zm64.6 5.2c2.7 3.9 4.6 8.3 5.6 13.2 1.1 6 .6 11.8-1.2 17.5 9.9 2.6 18.9 6.1 26.7 10.5 4.4 2.4 8.5 5.3 12.1 8.3 9-2.1 16.6-5.1 22-8.7v20.6c16.1-7.6 23.5-16.9 23.5-24.3 0-7.5-7.4-16.8-23.6-24.4-16.1-7.5-39.3-12.6-65.1-12.7zm111.8 5c-.1.4-.1.9-.1 1.4 0 8.7 7.6 18.6 23.8 26.8 16.2 8.1 39.6 13.5 65.7 13.5 13.2 0 25.7-1.4 37-3.8v-26.9c-14.8 4-31.5 6.2-49.1 6.2-28.6 0-54.5-5.7-74.1-15.5-1.1-.6-2.2-1.2-3.2-1.7zm2.8 37.3c-2 3.3-2.9 6.5-2.9 9.6 0 8.7 7.6 18.6 23.8 26.8 16.2 8.1 39.6 13.5 65.7 13.5 13.2 0 25.7-1.4 37-3.8v-26.4c-11.6 2.2-24 3.4-37 3.4-28.6 0-54.5-5.7-74.1-15.6-4.5-2.2-8.7-4.7-12.5-7.5zm173.1 0c-5.8 3.9-10.9 7-16.7 9.5v24.6c13.3-7.6 19.6-16.6 19.6-24.5 0-3.1-.9-6.3-2.9-9.6zm-292.6 5.4c-3.5 4.4-7.6 8.6-12.2 12.4-15.6 13.1-37.6 23.7-63 29.6-9.06 2.1-18.06 3.4-26.7 4.1 3.2 5.3 8.83 10.5 17.07 15.1 13.63 7.7 33.63 12.9 55.83 12.9 10.1 0 19.7-1.1 28.5-3v-20.8c13.8-2.1 25.4-5.9 32.8-10.8v18.4c10-7 14.8-14.9 14.8-22.4 0-8.7-6.5-18-20.2-25.7-7.4-4.1-16.6-7.5-26.9-9.8z"></path>
	</svg>
);

export const ndrSvg = (
	<svg
		stroke="currentColor"
		fill="currentColor"
		strokeWidth="0"
		viewBox="0 0 16 16"
		height="1em"
		width="1em"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
		<path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"></path>
	</svg>
);

export const cancelOrderSvg = (
	<svg
		stroke="currentColor"
		fill="currentColor"
		strokeWidth="0"
		viewBox="0 0 512 512"
		height="1em"
		width="1em"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="32"
			d="M432 144l-28.67 275.74A32 32 0 01371.55 448H140.46a32 32 0 01-31.78-28.26L80 144"
		></path>
		<rect
			width="448"
			height="80"
			x="32"
			y="64"
			fill="none"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="32"
			rx="16"
			ry="16"
		></rect>
		<path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M312 240L200 352m112 0L200 240"></path>
	</svg>
);

export const totalOrdersSvg = (
	<svg
		stroke="currentColor"
		fill="currentColor"
		strokeWidth="0"
		viewBox="0 0 16 16"
		height="1em"
		width="1em"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2l-2.218-.887zm3.564 1.426L5.596 5 8 5.961 14.154 3.5l-2.404-.961zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z"></path>
	</svg>
);

export const insightsIconSvg = (
	<svg
		stroke="currentColor"
		fill="currentColor"
		strokeWidth="0"
		viewBox="0 0 16 16"
		height="2rem"
		width="1.2rem"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.5 14H15v-1H2V0H1v13.5l.5.5zM3 11.5v-8l.5-.5h2l.5.5v8l-.5.5h-2l-.5-.5zm2-.5V4H4v7h1zm6-9.5v10l.5.5h2l.5-.5v-10l-.5-.5h-2l-.5.5zm2 .5v9h-1V2h1zm-6 9.5v-6l.5-.5h2l.5.5v6l-.5.5h-2l-.5-.5zm2-.5V6H8v5h1z"
		></path>
	</svg>
);
